export interface APIBaseUrls {
  assetsOriginBaseUrl: string
  configstoreApiBaseUrl: string
  eventApiBaseUrl: string
  lfcApiBaseUrl: string
  scensumBaseUrl: string
  skbvApiBaseUrl: string
  webshopApiBaseUrl: string
  internalDataBaseUrl: string
}
// Read DOM attributes at call time to avoid timing issues in dev where a
// bootstrap script copies dataset values onto a placeholder element before
// the React app runs. Reading at module load time can capture empty values.
export const getBaseUrls = (): APIBaseUrls => {
  const rootElement = document.getElementById('mok-context-spa')

  if (!rootElement) throw new Error('React root element is missing: "mok-context-spa"')

  // Try both attribute and dataset forms. In some dev flows the bootstrap
  // script copies values as dataset properties (camelCase), so prefer those
  // if present.
  const ds = rootElement.dataset

  const ASSETS_ORIGIN_BASE_URL =
    rootElement.getAttribute('data-assets-origin-url') || ds.assetsOriginUrl || ''
  const LFC_API_BASE_URL = rootElement.getAttribute('data-lfc-api-base-url') || ds.lfcApiBaseUrl || ''
  const CONFIGSTORE_API_BASE_URL =
    rootElement.getAttribute('data-configstore-api-url') || ds.configstoreApiUrl || ''
  const EVENT_API_BASE_URL = rootElement.getAttribute('data-event-api-url') || ds.eventApiBaseUrl || ''
  const SCENSUM_BASE_URL = rootElement.getAttribute('data-scensum-base-url') || ds.scensumBaseUrl || ''
  const SKBV_API_BASE_URL = rootElement.getAttribute('data-skbv-api-url') || ds.skbvApiBaseUrl || ''
  const WEBSHOP_API_BASE_URL =
    rootElement.getAttribute('data-webshop-api-base-url') || ds.webshopApiBaseUrl || ''
  const INTERNAL_DATA_BASE_URL =
    rootElement.getAttribute('data-internal-data-base-url') || ds.internalDataBaseUrl || ''

  if (!ASSETS_ORIGIN_BASE_URL?.length) throw new Error('Assets origin base URL is not defined')
  if (!LFC_API_BASE_URL?.length) throw new Error('LFC API base URL is not defined')
  if (!CONFIGSTORE_API_BASE_URL?.length) throw new Error('Configstore API base URL is not defined')
  if (!EVENT_API_BASE_URL?.length) throw new Error('Event API base URL is not defined')
  if (!SCENSUM_BASE_URL?.length) throw new Error('Scensum base URL is not defined')
  if (!SKBV_API_BASE_URL?.length) throw new Error('SKBV API base URL is not defined')
  if (!WEBSHOP_API_BASE_URL?.length) throw new Error('Webshop API base URL is not defined')
  if (!INTERNAL_DATA_BASE_URL?.length) throw new Error('Internal data base URL is not defined')

  return {
    assetsOriginBaseUrl: ASSETS_ORIGIN_BASE_URL,
    configstoreApiBaseUrl: CONFIGSTORE_API_BASE_URL,
    eventApiBaseUrl: EVENT_API_BASE_URL,
    lfcApiBaseUrl: LFC_API_BASE_URL,
    scensumBaseUrl: SCENSUM_BASE_URL,
    skbvApiBaseUrl: SKBV_API_BASE_URL,
    webshopApiBaseUrl: WEBSHOP_API_BASE_URL,
    internalDataBaseUrl: INTERNAL_DATA_BASE_URL
  }
}
